import React, { useEffect, useState } from "react";

import { api } from "../lib/api";
import { CompanySelection, Contact, ContactSelection } from "../types/crm";

const NEW_OPTION = "__new__";

interface ContactPickerProps {
  companySelection: CompanySelection;
  value: ContactSelection;
  onChange: (value: ContactSelection) => void;
}

export function ContactPicker({ companySelection, value, onChange }: ContactPickerProps) {
  const [contacts, setContacts] = useState<Contact[]>([]);

  useEffect(() => {
    if (companySelection.type !== "existing") {
      setContacts([]);
      onChange({ type: "new", data: { name: "", email: "", phone: "", role: "" } });
      return;
    }
    api
      .get<Contact[]>("/contacts/", { params: { company: companySelection.id } })
      .then((response) => setContacts(response.data))
      .catch(() => setContacts([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [companySelection.type === "existing" ? companySelection.id : null]);

  const isNewCompany = companySelection.type !== "existing";
  const selectValue = value.type === "existing" ? String(value.id) : NEW_OPTION;

  return (
    <div>
      <label htmlFor="contact" className="block text-sm font-medium text-slate-700">
        Contato principal
      </label>

      {!isNewCompany && (
        <select
          id="contact"
          value={selectValue}
          onChange={(event) => {
            const raw = event.target.value;
            if (raw === NEW_OPTION) {
              onChange({ type: "new", data: { name: "", email: "", phone: "", role: "" } });
            } else {
              onChange({ type: "existing", id: Number(raw) });
            }
          }}
          className="mt-1 block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
        >
          <option value="" disabled>
            Selecione um contato
          </option>
          {contacts.map((contact) => (
            <option key={contact.id} value={contact.id}>
              {contact.name}
            </option>
          ))}
          <option value={NEW_OPTION}>+ Cadastrar novo contato</option>
        </select>
      )}

      {isNewCompany && (
        <p className="mt-1 text-xs text-slate-500">
          Empresa nova — cadastre o contato principal abaixo.
        </p>
      )}

      {value.type === "new" && (
        <div className="mt-2 space-y-2 rounded-[10px] border border-border-subtle bg-surface p-3">
          <label htmlFor="contact_name" className="sr-only">
            Nome do contato
          </label>
          <input
            id="contact_name"
            type="text"
            placeholder="Nome do contato"
            value={value.data.name}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, name: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
          <label htmlFor="contact_email" className="sr-only">
            Email
          </label>
          <input
            id="contact_email"
            type="email"
            placeholder="Email (opcional)"
            value={value.data.email}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, email: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
          <label htmlFor="contact_phone" className="sr-only">
            Telefone
          </label>
          <input
            id="contact_phone"
            type="text"
            placeholder="Telefone (opcional)"
            value={value.data.phone}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, phone: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
          <label htmlFor="contact_role" className="sr-only">
            Cargo
          </label>
          <input
            id="contact_role"
            type="text"
            placeholder="Cargo (opcional)"
            value={value.data.role}
            onChange={(event) =>
              onChange({ type: "new", data: { ...value.data, role: event.target.value } })
            }
            className="block w-full rounded-[10px] border border-border-subtle px-3 py-2 text-sm focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
          />
        </div>
      )}
    </div>
  );
}
